import {
    SPORTSMEN_DELETE_FAILURE,
    SPORTSMEN_DELETE_REQUEST,
    SPORTSMEN_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const sportsmanDeleteReducer = (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case SPORTSMEN_DELETE_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
        }}

        case SPORTSMEN_DELETE_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case SPORTSMEN_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
